import { render, staticRenderFns } from "./NfCoreRnaSeqSetup.vue?vue&type=template&id=d254c10e"
import script from "./NfCoreRnaSeqSetup.vue?vue&type=script&lang=ts"
export * from "./NfCoreRnaSeqSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports